<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'

export default {
  components: {
    Label
  },

  props: {
    label: {
      type: String
    },
    value: {
      required: true,
      validator: v => typeof v === 'string' || v === null
    },
    placeholder: {
      type: String,
      default: 'Digite o texto...'
    },
    validationRules: {
      type: String,
      default: ''
    },
    config: {
      default: () => ({
        lang: 'pt_br',
        tagsToRemove: ['script', 'link'],
        removeformatPasted: true,
        btns: [
          ['strong', 'italic', 'underline', 'strikethrough'],
          ['removeformat'],
          ['formatting'],
          ['unorderedList', 'orderedList'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['undo', 'redo']
        ],
        semantic: {
          'br': '/br'
        }
      })
    }
  },

  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isRequired () {
      return this.validationRules.includes('required')
    }
  },

  methods: {
    onBlur () {
      this.$refs.validation.validate()
    }
  }
}
</script>

<template>
  <div>
    <validation-provider ref="validation" :rules="validationRules" v-slot="{ errors }" :name="label" mode="eager">
      <Label v-if="label" :label="label" :obrigatorio="isRequired" class="mb-25px" />
      <trumbowyg
        v-model="modelValue"
        @tbw-blur="onBlur"
        :config="config"
        :placeholder="placeholder"
      />
      <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
      </validation-provider>
  </div>
</template>

<style lang="scss">
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputTextEditor/InputTextEditor.vue